namespace advisorop.components.widgets {

    enum Asset {
        Core,
        Alternative
    }
    
    export class GaugePieAllocationCoreAlternativeController{
        alternativeValue;
        coreValue;
        rtgName: string;    
        chart;

        updateGauge() {
            this.chart = {
                "chart": {
                    //"caption": this.titleData,      
                    "startingangle": "240",
                    "showlabels": "1",
                    //"showlegend": "1",
                    //"enablemultislicing": "1",
                    "enableSmartLabels": "1",
                    "manageLabelOverflow": "1",
                    "useEllipsesWhenOverflow": "1",
                    "pieRadius": "100",
                    "slicingdistance": "5",
                    "showvalues": "1",
                    "showpercentvalues": "1",
                    "showpercentintooltip": "1",
                    "decimals": "1",
                    "labelFontSize": "11",
                    "showvalueintooltip": "1",
                    "use3dlighting": "1",
                    "radius3D": "10",
                    "plottooltext": "$label, $percentvalue",
                    "theme": "fint"
                },
                "data": [
                    {
                        "label": "Core",
                        "value": this.coreValue,
                        "color": "#6497b1",
                    },
                    {
                        "label": "Alternative",
                        "value": this.alternativeValue,
                        "color": "#b3cde0",
                    }]
            };
        };

        constructor(private advisorService: services.AdvisorService) {
                                
        }
      

        $onChanges(evt) {
            for (var key in evt) {
                if (key === "alternativeValue" && this.alternativeValue >= 0) {
                    //console.log("Updating gauge to:" + this.alternativeValue);
                    this.coreValue = Math.round((100 - this.alternativeValue) * 100) / 100;
                    this.updateGauge();
                }
            }
        }

        $onInit(): void {
            if (this.alternativeValue == undefined) {
                this.alternativeValue = 0;
            }
            this.updateGauge();            
        }

        $routerOnActivate(next, previous) {
            
        }        

    }



    class GaugePieAllocationCoreAlternative implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.bindings = {
                alternativeValue: "<",
                rtgName: "<"
            };
            this.controller = ["advisorService", GaugePieAllocationCoreAlternativeController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/gauge-pie-allocation-core-alternative.html';            
        }
    }
    angular.module(Constants.APP).component("gaugePieAllocationCoreAlternative", new GaugePieAllocationCoreAlternative());
    
}